<template>
  <el-dialog
    :title="$t('editReportCustom.editReport')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      :model="editReportCustomInfo"
      label-width="120px"
      label-position="left"
    >
      <el-form-item
        :label="$t('editReportCustom.reportGroup')"
        prop="groupId"
        :rules="[
          { required: true, message: $t('editReportCustom.groupRequired'), trigger: 'blur' },
          { max: 30, message: $t('editReportCustom.groupMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-select
          v-model="editReportCustomInfo.groupId"
          style="width: 100%"
          :placeholder="$t('editReportCustom.selectGroup')"
        >
          <el-option
            v-for="(item, index) in editReportCustomInfo.reportCustomGroups"
            :key="index"
            :label="item.name"
            :value="item.groupId"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('editReportCustom.title')"
        prop="title"
        :rules="[
          { required: true, message: $t('editReportCustom.titleRequired'), trigger: 'blur' },
          { max: 64, message: $t('editReportCustom.titleMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="editReportCustomInfo.title"
          :placeholder="$t('editReportCustom.inputTitle')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('editReportCustom.sort')"
        prop="seq"
        :rules="[
          { required: true, message: $t('editReportCustom.sortRequired'), trigger: 'blur' },
          { max: 11, message: $t('editReportCustom.sortMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="editReportCustomInfo.seq"
          :placeholder="$t('editReportCustom.inputSort')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('editReportCustom.description')"
        prop="remark"
        :rules="[
          { max: 512, message: $t('editReportCustom.descriptionMaxLength'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="editReportCustomInfo.remark"
          type="textarea"
          :placeholder="$t('editReportCustom.inputDescription')"
          :rows="3"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editReportCustom">
        <i class="el-icon-check"></i>
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateReportCustom, listReportCustomGroups } from '@/api/dev/reportCustomApi'

export default {
  name: 'EditReportCustom',
  data() {
    return {
      dialogVisible: false,
      editReportCustomInfo: {
        customId: '',
        groupId: '',
        title: '',
        seq: '',
        remark: '',
        reportCustomGroups: []
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.editReportCustomInfo = { ...row }
      this._listEditReportCustomGroups()
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.editReportCustomInfo = {
        customId: '',
        groupId: '',
        title: '',
        seq: '',
        remark: '',
        reportCustomGroups: []
      }
    },
    async editReportCustom() {
      try {
        await this.$refs.form.validate()
        const res = await updateReportCustom(this.editReportCustomInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('editReportCustom.editSuccess'))
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async _listEditReportCustomGroups() {
      try {
        const res = await listReportCustomGroups({ page: 1, row: 50 })
        this.editReportCustomInfo.reportCustomGroups = res.data
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>